import angular from "angular";

const health = function ($resource) {
  'ngInject';

  return $resource('/api/v1/public/version', {}, {})
}

export default angular.module('vt-public-resource.health', [])
  .service('HealthPublicApi', health);
